"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Redirect = void 0;
const tslib_1 = require("tslib");
const ChannelInstructionType_1 = require("../channelInstruction/ChannelInstructionType");
const Config_1 = require("../Config");
const MessageType_1 = require("../message/MessageType");
const Error_1 = require("../shared/Error");
const IResult_1 = require("../shared/IResult");
const RedirectHelper_1 = require("./RedirectHelper");
class Redirect {
    constructor(request, endpointEngagedHandler) {
        this.request = request;
        this.endpointEngagedHandler = endpointEngagedHandler;
        this.userInteractionRequired = this.isUserInteractionRequired();
        if (this.request.payload.channelInstruction.uiPages && this.request.payload.channelInstruction.uiPages.length > 0) {
            this.uiContent = this.request.payload.channelInstruction.uiPages[0];
        }
        else {
            this.uiContent = this.request.payload.channelInstruction.uiContentJSON;
        }
        if (!this.userInteractionRequired) {
            setTimeout(() => {
                this.redirect();
            }, Config_1.config.redirectDelayInMilliseconds);
        }
    }
    proceed() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.userInteractionRequired) {
                const endpointEngagedRequest = {
                    messageName: MessageType_1.MessageType.EndpointEngagedRequest,
                    payload: {
                        channelInstruction: {
                            type: this.request.payload.channelInstruction.type,
                        },
                        messageID: this.request.payload.messageID,
                        interaction: {
                            entersektInteractionID: this.request.payload.interaction.entersektInteractionID,
                            type: this.request.payload.interaction.type,
                        },
                        result: {
                            action: IResult_1.Action.APPROVED,
                        },
                    },
                };
                yield this.endpointEngagedHandler.endpointEngaged(endpointEngagedRequest);
                return this.redirect();
            }
            else {
                return Promise.resolve();
            }
        });
    }
    redirect() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.request.payload.channelInstruction.instructionURI)
                return Promise.reject(Error_1.CustomerAuthnError.INTERNAL_ERROR);
            const postType = this.getPostType();
            if (postType === PostType.IFRAME || postType === PostType.POPUP) {
                this.postMessage();
            }
            else if (postType === PostType.NONE) {
                const redirectURL = yield RedirectHelper_1.RedirectHelper.appendQueryParamToURL(this.request.payload.channelInstruction.instructionURI, "entersektInteractionID", this.request.payload.interaction.entersektInteractionID);
                window.location.href = redirectURL;
            }
        });
    }
    isUserInteractionRequired() {
        if (this.request.payload.channelInstruction.type === ChannelInstructionType_1.ChannelInstructionType.REDIRECT_PAUSE) {
            return true;
        }
        else
            return false;
    }
    getPostType() {
        if (window.self && window.self !== window.top) {
            return PostType.IFRAME;
        }
        else if (window.opener && window.opener !== window) {
            return PostType.POPUP;
        }
        else {
            return PostType.NONE;
        }
    }
    postMessage() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const type = this.getPostType();
                if (!this.request.payload.channelInstruction.instructionURI)
                    return Promise.reject(Error_1.CustomerAuthnError.INTERNAL_ERROR);
                const url = new URL(this.request.payload.channelInstruction.instructionURI);
                if (type == PostType.IFRAME) {
                    window.parent.postMessage(this.request.payload.interaction, url.origin);
                }
                else if (type == PostType.POPUP) {
                    window.opener.postMessage(this.request.payload.interaction, url.origin);
                }
            }
            catch (_error) {
                return Promise.reject(Error_1.CustomerAuthnError.INTERNAL_ERROR);
            }
        });
    }
}
exports.Redirect = Redirect;
var PostType;
(function (PostType) {
    PostType["NONE"] = "NONE";
    PostType["POPUP"] = "POPUP";
    PostType["IFRAME"] = "IFRAME";
})(PostType || (PostType = {}));
//# sourceMappingURL=Redirect.js.map